import { createSelector } from '@reduxjs/toolkit';

import { AppState } from 'store/store';
import { MAX_STARRED_REPORT_COUNT } from 'store/star-report/constants';

export const selectStarReport = (state: AppState) => state.starReport;

export const selectStarReportIsReportListLoaded = createSelector(
    selectStarReport,
    (starReport) => starReport.reports !== undefined,
);

export const selectStarReportIsLoading = createSelector(
    selectStarReport,
    (starReport) => starReport.reports === undefined,
);

export const selectStarReportIsSaving = createSelector(
    selectStarReport,
    (starReport) => starReport.processingApiAction === 'saving',
);

export const selectStarReportIsUpdating = createSelector(
    selectStarReport,
    (starReport) => starReport.processingApiAction === 'updating',
);

export const selectStarReportIsRemoving = createSelector(
    selectStarReport,
    (starReport) => starReport.processingApiAction === 'removing',
);

export const selectStarReportChangesProcessing = createSelector(
    selectStarReportIsSaving,
    selectStarReportIsUpdating,
    selectStarReportIsRemoving,
    (isSaving, isUpdating, isRemoving) => isSaving || isUpdating || isRemoving,
);

export const selectStarReportReports = createSelector(
    selectStarReport,
    (starReport) => starReport.reports || [],
);

export const selectStarReportHasMaxReports = createSelector(
    selectStarReportReports,
    (reports) => reports.length >= MAX_STARRED_REPORT_COUNT,
);
